import React from "react";
import { Camera, Image as ImageIcon, CalendarClock, Trash2 } from "lucide-react";
import TrafficLight from "@/components/TrafficLight";
import SmartMenu from "@/components/SmartMenu";
import { trafficStatus } from "@/components/CertModal";

/** Single existing certification row (with photo upload/view + 3-dot menu). */
export default function CertCard({ cert, isAdmin, onView, onUpload, onEdit, onDisable }) {
  const status = cert.status || trafficStatus(cert.expiration_date);

  const menuItems = [
    {
      label: "Update Expiration Date",
      icon: CalendarClock,
      onClick: () => onEdit(cert),
      testId: `menu-update-${cert.id}`,
    },
    {
      label: "Disable Certification",
      icon: Trash2,
      onClick: () => onDisable(cert),
      danger: true,
      testId: `menu-disable-${cert.id}`,
      hidden: !(isAdmin && !cert.disabled),
    },
  ];

  return (
    <div className={`border-2 p-3 ${cert.disabled ? "opacity-50 border-foreground/30" : "border-foreground dark:border-safety-yellow"}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0 flex-1">
          <div className="font-heading text-lg leading-tight truncate">{cert.cert_type}</div>
          <div className="text-xs text-muted-foreground mt-1">Exp: {cert.expiration_date}</div>
        </div>
        <TrafficLight status={status} size="sm" />
      </div>

      <div className="flex items-center gap-2 mt-3 flex-wrap">
        {cert.photo_path ? (
          <button
            data-testid={`view-photo-${cert.id}`}
            type="button"
            onClick={() => onView(cert)}
            className="min-h-[48px] px-3 border-2 border-foreground dark:border-safety-yellow hover:bg-safety-yellow hover:text-black text-xs font-bold uppercase tracking-wider inline-flex items-center gap-2"
          >
            <ImageIcon className="w-4 h-4" strokeWidth={2.5} /> View Photo
          </button>
        ) : (
          <label
            data-testid={`upload-photo-${cert.id}`}
            className="cursor-pointer min-h-[48px] px-3 border-2 border-foreground dark:border-safety-yellow hover:bg-safety-yellow hover:text-black text-xs font-bold uppercase tracking-wider inline-flex items-center gap-2"
          >
            <Camera className="w-4 h-4" strokeWidth={2.5} /> Upload Photo
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => e.target.files?.[0] && onUpload(cert, e.target.files[0])}
            />
          </label>
        )}

        <div className="ml-auto">
          <SmartMenu testId={`cert-menu-${cert.id}`} items={menuItems} />
        </div>
      </div>
    </div>
  );
}
